/* DENSA — COĞRAFYA KARUSELİ DÜZELTME KATMANI v2.2 (11 Ağu 2026)

   Kurucu bildirimi: "geçişler akıcı değil, takılıyor" · "mobilde bir sonrakine geçince
   küçülüp yeniden büyüyor, bir sonraki hemen gözükmüyor" · "yanlardaki karta tıklayınca
   da geçiş olsun".

   Motor (densa-karusel.js) küçültülmüş hâlde okundu. BEŞ kusur bulundu; hepsi motor
   dosyasına HİÇ DOKUNULMADAN dışarıdan kapatıldı.

   ① NATİVE SMOOTH — motorun git()'i scrollTo({behavior:"smooth"}) kullanıyordu; süresi ve
     eğrisi tarayıcıya göre değişir, scroll-snap ile kesintiye uğrar. Formül karuselinde bu
     zaten rAF ile değiştirilmişti, coğrafyaya geçmemiş.
     → serit.scrollTo örnek düzeyinde devralındı: tüm geçiş yolları (ok, kart tıklaması,
       dokunmatik jest, sürükleme bırakışı) tek ve aynı rAF easeInOutCubic'ten geçiyor.

   ② SNAP KAVGASI — şeritte scroll-snap-type:x mandatory, mobilde kartlarda
     scroll-snap-stop:always. Programlı kaydırma her yapışma noktasında kesiliyordu.
     → yalnız animasyon sürerken snap kapalı (.dcg-gecisiyor).

   ③ KLON GÖRSELLERİ TEMBEL — cloneNode(true) loading="lazy"yi de kopyalıyor, sarmada kart
     boş geliyordu. → tüm şerit görselleri eager + önbelleğe ısıtılıyor.

   ④ YAN KARTA TIKLAMA — kusur BENİM v1.x katmanımdandı: pointerdown anında 'tutuluyor'
     sınıfı veriliyordu, CSS'te .tutuluyor .dcg-kart{pointer-events:none} var.
     → 'tutuluyor' artık hiç verilmiyor; imleç geri bildirimi ayrı sınıfla.

   ⑤ v2.2 — "KÜÇÜLÜP YENİDEN BÜYÜME"NİN GERÇEK SEBEBİ (ölçümle bulundu, YARIŞ DURUMU):
     Ölçüm şunu gösterdi — motor doğru davranıp hedef kartı başta işaretliyor
     (scroll 335'te kart 2), ama İKİ KARE SONRA geri alıyor (scroll 337'de kart 1),
     sonra ortada tekrar ileri alıyor (scroll 528'de kart 2). Üç değişim = gözüken titreme.
     KÖK NEDEN: motorun rAF izleyicisi şöyle çalışıyor — "scrollLeft değiştiyse boya(),
     DEĞİŞMEDİYSE ve 120ms geçtiyse hedefBekliyor=false". Karusel boşta beklerken
     "120ms'dir hareket yok" koşulu ZATEN doğru. Jest başladığı anda hedef işaretleniyor,
     ama animasyonun İLK KARESİ t=0 olduğu için sıfır ilerleme üretiyor → izleyici o karede
     "hareket yok" deyip kilidi AÇIYOR → sonraki karede boya() korumasız çalışıp işareti
     en yakın karta (hâlâ eski kart) geri alıyor.
     → ÇÖZÜM: animasyon başlarken şeride SENKRON 1 piksellik itme yapılıyor. Böylece izleyici
       daha ilk bakışında "hareket var" görüyor, kilit açılmıyor ve hedef işareti animasyon
       boyunca ayakta kalıyor. 1 piksel gözle görülmez; kilidin açılmaması her şeyi çözer.
     Ayrıca ışınlanma (sonsuz sarma) anında klon↔asıl kimlik değişimi canlandırma üretmesin
     diye geçişler kısa süre kapatılıyor (.dcg-anlik). Ana sayfada sarma kapalı (data-sarmasiz),
     bu kalkan PDP'deki sarmalı şerit için çalışır.

   KORUNAN: imleç milim de çekse metre de çekse TEK kart; teker/trackpad mandalı jest başına
   tek adım; dokunmatik motorun kendi jestinde kalır.
   HATA GÜVENLİĞİ: her şey try/catch; katman kurulamazsa motor eski hâliyle çalışır.
   Yükleme noktası: snippets/densa-istek.liquid (ana sayfa + PDP aynı sınıflar). */
(function () {
  var ESIK = 25;
  var TASIMA = 8;
  var YUTMA_MS = 350;
  var SURE = 460;
  var ANLIK_MS = 90;

  function stilKur() {
    if (document.getElementById('densa-dcg-stil')) return;
    var s = document.createElement('style');
    s.id = 'densa-dcg-stil';
    s.textContent =
      '.dcg .dcg-serit.dcg-gecisiyor{scroll-snap-type:none !important;}' +
      '.dcg .dcg-serit.dcg-gecisiyor .dcg-kart{scroll-snap-stop:normal !important;}' +
      '.dcg .dcg-serit.dcg-tutus{cursor:grabbing;}' +
      '.dcg .dcg-serit.dcg-anlik .dcg-kart,' +
      '.dcg .dcg-serit.dcg-anlik .dcg-medya,' +
      '.dcg .dcg-serit.dcg-anlik .dcg-govde,' +
      '.dcg .dcg-serit.dcg-anlik .dcg-ust,' +
      '.dcg .dcg-serit.dcg-anlik .dcg-madalyon,' +
      '.dcg .dcg-serit.dcg-anlik .dcg-cumle{transition:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function kur(sahne) {
    if (sahne.dataset.adimKuruldu === '2.2') return;
    var serit = sahne.querySelector('.dcg-serit');
    var sag = sahne.querySelector('.dcg-ok.sag');
    var sol = sahne.querySelector('.dcg-ok.sol');
    if (!serit || !sag || !sol) return;
    var ilk = !sahne.dataset.adimKuruldu;
    sahne.dataset.adimKuruldu = '2.2';
    stilKur();
    if (!ilk) return;

    var animId = null;
    var yerelScrollTo = serit.scrollTo ? serit.scrollTo.bind(serit) : null;

    function bitir() { try { serit.classList.remove('dcg-gecisiyor'); } catch (h) {} }
    function durdur() {
      if (animId !== null) { try { cancelAnimationFrame(animId); } catch (h) {} animId = null; bitir(); }
    }

    function suru(hedefX) {
      durdur();
      var bas = serit.scrollLeft, mesafe = hedefX - bas;
      if (!isFinite(mesafe)) return;
      if (Math.abs(mesafe) < 1) { serit.scrollLeft = hedefX; return; }
      try { serit.classList.add('dcg-gecisiyor'); } catch (h) {}
      /* ⑤ KRİTİK: senkron 1 piksellik itme. Motorun izleyicisi bir sonraki karede
         "hareket var" görmeli; görmezse hedef kilidini açıyor ve işareti geri alıyor. */
      try { serit.scrollLeft = bas + (mesafe > 0 ? 1 : -1); } catch (h) {}
      var t0 = null;
      function ciz(ts) {
        try {
          if (t0 === null) t0 = ts;
          var t = Math.min(1, (ts - t0) / SURE);
          var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          serit.scrollLeft = bas + mesafe * e;
          if (t < 1) { animId = requestAnimationFrame(ciz); return; }
          animId = null;
          serit.scrollLeft = hedefX;
          requestAnimationFrame(bitir);
        } catch (h) { animId = null; try { serit.scrollLeft = hedefX; } catch (g) {} bitir(); }
      }
      animId = requestAnimationFrame(ciz);
    }

    try {
      serit.scrollTo = function (opts) {
        try {
          if (!opts || typeof opts.left !== 'number') {
            return yerelScrollTo ? yerelScrollTo.apply(serit, arguments) : undefined;
          }
          if (opts.behavior === 'auto') { durdur(); serit.scrollLeft = opts.left; return; }
          suru(opts.left);
        } catch (h) {
          try { serit.scrollLeft = (opts && opts.left) || serit.scrollLeft; } catch (g) {}
        }
      };
    } catch (h) {}

    /* IŞINLANMA KALKANI — klon↔asıl kimlik değişimi canlandırma üretmesin */
    var anlikSaat = null;
    try {
      new MutationObserver(function () {
        try {
          var st = serit.style;
          if (st.scrollSnapType === 'none' || st.scrollBehavior === 'auto') {
            serit.classList.add('dcg-anlik');
            clearTimeout(anlikSaat);
            anlikSaat = setTimeout(function () {
              try { serit.classList.remove('dcg-anlik'); } catch (h) {}
            }, ANLIK_MS);
          }
        } catch (h) {}
      }).observe(serit, { attributes: true, attributeFilter: ['style'] });
    } catch (h) {}

    function gorselleriAc() {
      try {
        Array.prototype.forEach.call(serit.querySelectorAll('img'), function (g) {
          try {
            if (g.getAttribute('loading') === 'lazy') {
              g.setAttribute('loading', 'eager');
              g.setAttribute('fetchpriority', 'low');
            }
            if (!g.complete) {
              var u = g.currentSrc || g.getAttribute('src');
              if (u) { (new Image()).src = u; }
            }
          } catch (h) {}
        });
      } catch (h) {}
    }
    gorselleriAc();
    setTimeout(gorselleriAc, 800);
    setTimeout(gorselleriAc, 2500);

    function adim(yon) { try { (yon > 0 ? sag : sol).click(); } catch (h) {} }

    var basX = null, tasindi = false, yutmaSonu = 0;

    sahne.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      try { e.stopPropagation(); basX = e.clientX; tasindi = false; } catch (h) { basX = null; }
    }, true);

    window.addEventListener('pointermove', function (e) {
      if (basX === null) return;
      if (!tasindi && Math.abs(e.clientX - basX) > TASIMA) {
        tasindi = true;
        try { serit.classList.add('dcg-tutus'); } catch (h) {}
      }
    });

    function birak(e) {
      if (basX === null) return;
      var dx = (e && typeof e.clientX === 'number') ? (e.clientX - basX) : 0;
      basX = null;
      try { serit.classList.remove('dcg-tutus'); } catch (h) {}
      if (tasindi) yutmaSonu = Date.now() + YUTMA_MS;
      tasindi = false;
      if (Math.abs(dx) >= ESIK) adim(dx < 0 ? 1 : -1);
    }
    window.addEventListener('pointerup', birak);
    window.addEventListener('pointercancel', birak);
    window.addEventListener('blur', function () {
      basX = null; tasindi = false;
      try { serit.classList.remove('dcg-tutus'); } catch (h) {}
    });

    sahne.addEventListener('click', function (e) {
      try {
        if (Date.now() > yutmaSonu) return;
        if (e.target && e.target.closest && e.target.closest('.dcg-ok')) return;
        e.preventDefault(); e.stopPropagation();
      } catch (h) {}
    }, true);

    var birikim = 0, kilit = false, saat = null;
    serit.addEventListener('wheel', function (e) {
      try {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        if (e.cancelable) e.preventDefault();
        clearTimeout(saat);
        saat = setTimeout(function () { kilit = false; birikim = 0; }, 120);
        if (kilit) return;
        birikim += e.deltaX;
        if (Math.abs(birikim) < ESIK) return;
        var yon = birikim > 0 ? 1 : -1;
        birikim = 0; kilit = true;
        adim(yon);
      } catch (h) {}
    }, { passive: false });
  }

  function tara() {
    try {
      Array.prototype.forEach.call(document.querySelectorAll('.dcg .dcg-sahne'), function (s) {
        try { kur(s); } catch (h) {}
      });
    } catch (h) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara);
  else tara();
  window.addEventListener('load', function () { setTimeout(tara, 300); });
  setTimeout(tara, 1000);
  setTimeout(tara, 2600);
})();
